import React from 'react';

import BaseIcon, { BaseIconProps } from './BaseIcon';

const RefreshIcon = ({ viewBox, ...restProps }: BaseIconProps) => (
  <BaseIcon {...restProps} viewBox={viewBox || '0 0 12 10'}>
    <path
      d="M11.4567 4.43986L9.61665 6.30652C9.50998 6.41319 9.37665 6.46652 9.22998 6.46652C9.08331 6.46652 8.94999 6.41319 8.84333 6.30652L7.00332 4.43986C6.80332 4.22652 6.80332 3.89319 7.00332 3.67986C7.21665 3.47986 7.54998 3.47986 7.76331 3.67986L8.78999 4.71986C8.65666 2.78652 7.06999 1.25319 5.13665 1.25319C3.10999 1.25319 1.46999 2.93319 1.46999 4.98652C1.46999 7.03986 3.10999 8.71986 5.13665 8.71986C5.88332 8.71986 6.60332 8.49319 7.20332 8.06652C7.44332 7.89319 7.77665 7.95986 7.94998 8.19986C8.12332 8.43986 8.05665 8.77319 7.81665 8.94652C7.02998 9.49319 6.09665 9.78652 5.13665 9.78652C2.52332 9.78652 0.40332 7.63986 0.40332 4.98652C0.40332 2.33319 2.52332 0.186523 5.13665 0.186523C7.58999 0.186523 9.61666 2.09319 9.84333 4.53319L10.6833 3.67986C10.8966 3.46652 11.23 3.46652 11.4433 3.67986C11.6567 3.89319 11.6567 4.22652 11.4567 4.43986Z"
      fill="#2371A5"
    />
  </BaseIcon>
);

export default RefreshIcon;
